<div class="h-100 d-flex align-items-center justify-content-center">
  @if (status === 'success') {
    <div>
      <div
        class="d-flex align-items-center justify-content-center bg-light rounded-circle m-auto large-icon text-center mb-3"
      >
        <mat-icon class="d-block w-fit h-fit display-1 text-success"
          >done</mat-icon
        >
      </div>
      <h5 class="m-auto text-center">Your payment was successful!</h5>
    </div>
  } @else if (status === 'fail') {
    <div>
      <div
        class="d-flex align-items-center justify-content-center bg-light rounded-circle m-auto large-icon text-center mb-3"
      >
        <mat-icon class="d-block w-fit h-fit display-1 text-danger"
          >close</mat-icon
        >
      </div>
      <h5 class="m-auto text-center">Your payment was unsuccessful</h5>
      <p class="m-auto text-center">
        Select the original link again to try a successful payment
      </p>
    </div>
  }
</div>
